import { Component, OnInit } from '@angular/core';
import { QuestionBatchService } from '../../shared/services/question-batch/question-batch.service'
import { QuestionBankService } from '../../shared/services/question-bank/question-bank.service'
import { NgbModal, } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { first } from "rxjs/operators";
import { AlertService, UploadTestTimingService } from "src/app/shared";
import { TestbatchService } from 'src/app/shared/services/test-batch/testbatch.service';




@Component({
  selector: 'app-question-batch',
  templateUrl: './question-batch.component.html',
  styleUrls: ['./question-batch.component.scss']
})
export class QuestionBatchComponent implements OnInit {
  tests: any;
  batch: any;
  selectedBatch: any;
  currentBatch: any;
  questionbank: any;
  qbid: any;
  testid: any;
  langid: any;
  _id: any;
  sender = "question-batch";
  batchData: any;

  constructor(private questionBatchService: QuestionBatchService,
    private modalService: NgbModal,
    private questionBankService: QuestionBankService,
    private alertService: AlertService,
    private uploadTestTimingService: UploadTestTimingService,
    private testbatchService: TestbatchService
  ) { }

  ngOnInit() {
    this.getBatch();
    this.getDashboard();
    if (this.qbid) {
      this.getQuesBatchById(this.qbid);
    }
  }

  getBatch() {
    this.testbatchService.getAll()
    .pipe(first())
    .subscribe(res => {
      this.batch = res;
    })
  }

  getDashboard() {
    this.questionBankService
      .getDashboard()
      .pipe(first())
      .subscribe(res => {
        this.tests = res;
        this.getQuestionBatches ();
      });
  }

  getBatchName(b) {
    var t = new Date();
    t.setHours(b.test_start_time.hour);
    t.setMinutes(b.test_start_time.minute);
    return b.test_date + " " + moment(t).format("hh:mm A");
  }

  onBatch(content, qbank) {
    this.questionbank = qbank;
    this.qbid = this.questionbank._id;
    this.testid = this.questionbank.testid;
    this.langid = this.questionbank.lang._id;
    this.modalService.open(content, { size: 'lg' });

  }

  onSubmit() {
    if (!this.selectedBatch || !this.selectedBatch.code) {
      this.alertService.err(this.sender, "Please select batch date and time");
      return false;
    }
    var data = {
      batch: this.selectedBatch,
      qbid: this.qbid,
    };
    this.questionBatchService.saveTestBatch(data).subscribe(res => {

      this.modalService.dismissAll();

      this.getQuestionBatches ();
      this.alertService.show(this.sender, "Question Bank Batch Details saved successfully");
    })
  }



  getQuestionBatches (){
    this.questionBatchService.getQuestionBatches ()
    .pipe(first())
    .subscribe (res=>{
      this.batchData = res;
      this.addBatchData ();
    });
    
  }

  addBatchData  (){
    //merge .. 
    //this.tests
    //this.batchData
    if (!this.batchData || !this.tests){
      return;
    }

    for (var i=0; i<this.tests.length; i++){
      var test = this.tests [i];
      for (var j=0; j< test.questionbanks.length; j++){

        var qb = test.questionbanks [j];
        for (var t=0; t <this.batchData.length; t++ ){

          if (qb._id == this.batchData [t].qbid){
            qb.batch = this.batchData [t].batch;
          }
        }

      }
    }


    //console.log ("this is my data ...", this.tests);
  }
  getQuesBatchById(qbid) {
    this.questionBatchService
      .getQuesBatchById(qbid)
      .pipe(first())
      .subscribe(res => {
        this.currentBatch = res;
      });
  }
}




